import type { Template } from "@/types";

export const LA_02_H2_V0: Template[] = [
    {
        id: "la-02-h2v0-01",
        name: "LA 01 - H2V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-02-h2_v0_01.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 55, y: 58, width: 566, height: 425, rotation: 0, imageRotation: 0 },
            { id: "2", x: 731, y: 58, width: 566, height: 425, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-02-h2v0-02",
        name: "LA 02 - H2V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-02-h2_v0_02.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 55, y: 58, width: 566, height: 425, rotation: 0, imageRotation: 0 },
            { id: "2", x: 779, y: 115, width: 470, height: 311, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-02-h2v0-03",
        name: "LA 03 - H2V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-02-h2_v0_03.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 79, y: 84, width: 515, height: 373, rotation: 0, imageRotation: 0 },
            { id: "2", x: 757, y: 84, width: 515, height: 373, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-02-h2v0-04",
        name: "LA 04 - H2V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-02-h2_v0_04.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 69, y: 111, width: 428, height: 320, rotation: 0, imageRotation: 0 },
            { id: "2", x: 571, y: 0, width: 782, height: 541, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-02-h2v0-05",
        name: "LA 05 - H2V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-02-h2_v0_05.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 855, y: 111, width: 428, height: 320, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 0, width: 782, height: 541, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-02-h2v0-06",
        name: "LA 06 - H2V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-02-h2_v0_06.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 54, y: 58, width: 569, height: 426, rotation: 0, imageRotation: 0 },
            { id: "2", x: 676, y: 0, width: 676, height: 541, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-02-h2v0-07",
        name: "LA 07 - H2V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-02-h2_v0_07.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 729, y: 58, width: 569, height: 426, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 0, width: 676, height: 541, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-02-h2v0-08",
        name: "LA 08 - H2V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-02-h2_v0_08.png",
        size: [1352, 541],
        style: {},
        slots: [        
            { id: "1", x: 102, y: 127, width: 471, height: 288, rotation: 0, imageRotation: 0 },
            { id: "2", x: 731, y: 58, width: 566, height: 425, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-02-h2v0-09",
        name: "LA 09 - H2V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-02-h2_v0_09.png",
        size: [1352, 541],
        style: {},
        slots: [          
            { id: "1", x: 55, y: 58, width: 566, height: 425, rotation: 0, imageRotation: 0 },
            { id: "2", x: 779, y: 127, width: 471, height: 288, rotation: 0, imageRotation: 0 }
        ],
    },
    {
        id: "la-02-h2v0-10",
        name: "LA 10 - H2V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-02-h2_v0_10.png",
        size: [1352, 541],
        style: {},
        slots: [       
            { id: "1", x: 137, y: 139, width: 399, height: 264, rotation: 0, imageRotation: 0 },
            { id: "2", x: 714, y: 45, width: 601, height: 450, rotation: 0, imageRotation: 0 }
        ],
    }
];